import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import s from './Stats.scss';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';

export interface Props {
  stats: object;
  isHeaderStickyOnMobile?: boolean;
  headerClassName?: string;
  widthBreakpoints?: number[];
}

export class Stats extends React.Component<Props & WithTranslation> {
  renderStatItems(stats) {
    const { t } = this.props;
    const statsToDisplay = [
      'pageviews',
      'deviations',
      'watchers',
      'watching',
      'favourites',
      'commentsMade',
      'commentsReceivedProfile',
    ];
    return statsToDisplay.map(entity => {
      return (
        <div key={entity} className={s['stat-item']}>
          <span className={s['stat-name']}>
            {t!(`common.${entity}`, { count: stats[entity] })}
          </span>
          {shortenNumber(stats[entity])}
        </div>
      );
    });
  }

  render() {
    const { stats } = this.props;
    if (!stats) {
      return null;
    }
    return (
      <ElementQueries
        className={s['stats-widget']}
        widthBreakpoints={[640, 800]}
      >
        {this.renderStatItems(stats)}
      </ElementQueries>
    );
  }
}

export default withTranslation()(Stats);
